import { CssBaseline, ThemeProvider } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import * as Sentry from "@sentry/browser";
import * as React from "react";

import theme from "@/theme";

import { CustomButton } from "./Button";
import { FullPageError } from "./StatePanels";

// WithAuthの外側の固定パス。認証状態やRouter自体の描画に依存せず復帰画面を出す。
const PUBLIC_PATHS = new Set([
  "/", "/onboarding", "/login", "/registrations", "/registration_intro", "/pre_diagnosis",
  "/password_reset", "/password_reset/new",
]);

// Router・Recoil・アプリの初期化自体で例外が起きても表示できるよう、それらの外側に置く。
export class AppErrorBoundary extends React.Component<React.PropsWithChildren<unknown>, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    // React 17本番版ではCaptureConsoleが先に同じErrorを送るため、この捕捉はSDKで重複排除される。
    // CaptureConsoleが捕捉しなかった場合の保険として残す。componentStackの追加送信は行わない。
    Sentry.captureException(error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
    const canGoHome = pathname !== "/mypage" && !PUBLIC_PATHS.has(pathname);

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FullPageError
          title="画面を表示できませんでした"
          description={"お手数ですが、再読み込みしてください。\n改善しない場合はお問い合わせをご利用ください。"}
          illustration={<ErrorOutlineIcon style={{ fontSize: 64, color: theme.palette.text.secondary }} />}
          action={
            <div style={{ display: "grid", gap: 12 }}>
              <CustomButton buttonSize="L" fullWidth onClick={() => window.location.reload()}>
                再読み込み
              </CustomButton>
              {canGoHome && (
                <CustomButton buttonSize="L" tone="outline" fullWidth onClick={() => window.location.assign("/mypage")}>
                  ホームへ戻る
                </CustomButton>
              )}
              <CustomButton
                buttonSize="L" tone="outline" fullWidth
                onClick={() => window.open("https://form.run/@propally-1619963249", "_blank", "noopener,noreferrer")}
              >
                お問い合わせ
              </CustomButton>
            </div>
          }
        />
      </ThemeProvider>
    );
  }
}
